import axios from "axios";

const API_BASE_URL = `${window.SERVER_PORT.url}`;

class AuthService {
  constructor() {
    this.apiBaseUrl = API_BASE_URL;
  }

  // Function to generate OTP
  async generateOtp(email) {

    try {
      const response = await axios.post(
        `${this.apiBaseUrl}/auth/generate-otp`,
        {
          email,
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        error.response?.data?.ErrorMessages || "Error generating OTP"
      );
      //   throw new Error(
      //     error.response?.data?.ErrorMessages || "Error generating OTP"
      //   );
    }
  }

  async verifyOtp(email, otp) {

    try {
      const response = await axios.post(`${this.apiBaseUrl}/auth/verify-otp`, {
        email,
        otp,
      });
      return response.data;
    } catch (error) {
      console.error(
        error.response?.data?.ErrorMessages || "Error verifying OTP"
      );
      throw error;
    }
  }

  async login(Username, password) {

    try {
      const response = await axios.post(`${this.apiBaseUrl}/auth/login`, {
        Username,
        password,
      });
      return response.data;
    } catch (error) {
      console.error(
        error.response?.data?.ErrorMessages || "Error verifying OTP"
      );
      //   throw new Error(
      //     error.response?.data?.ErrorMessages || "Error verifying OTP"
      //   );
    }
  }

  async generateOtpV1(email) {

    try {
      const response = await axios.post(
        `${this.apiBaseUrl}/auth/generate-otpv1`,
        {
          "email": email || "technical.techcherry@gmail.com"
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        error.response?.data?.ErrorMessages || "Error generating OTP"
      );
    }
  }

  async verifyOtpV1(email, otp) {

    try {
      const response = await axios.post(
        `${this.apiBaseUrl}/auth/verify-otpv1`,
        {
          "email": email || "technical.techcherry@gmail.com",
          "otp": otp
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        error.response?.data?.ErrorMessages || "Error generating OTP"
      );
    }
  }

}

export default new AuthService();
